import { UserAgentApplication } from "msal";

export const requiresInteraction = (errorMessage: any) => {
    if (!errorMessage || !errorMessage.length) {
        return false;
    }

    return (
        errorMessage.indexOf("consent_required") > -1 ||
        errorMessage.indexOf("interaction_required") > -1 ||
        errorMessage.indexOf("login_required") > -1
    );
};

export const fetchMsGraph = async (url: any, accessToken: any) => {
    sessionStorage.setItem('TOKEN', accessToken);
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });

    return response.json();
};

export const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ") > -1;
    const msie11 = ua.indexOf("Trident/") > -1;
    return msie || msie11;
};

export const GRAPH_SCOPES = {
    OPENID: "openid",
    PROFILE: "profile",
    USER_READ: "User.Read",
    MAIL_READ: "Mail.Read",
    USER_READ_ALL: "User.Read.All",
    //USER_READ_WRITE_ALL: "User.ReadWrite.All",
    DIRECTORY_READ_ALL: "Directory.Read.All,",
    //DIRECTORY_READ_WRITE_ALL: "Directory.ReadWrite.All",
    GROUP_READ_ALL: "Group.Read.All",
    //GROUP_READ_WRITE_ALL: "Group.ReadWrite.All"

};

export const GRAPH_ENDPOINTS = {
    ME: "https://graph.microsoft.com/v1.0/me",
    MEMBEROF: "https://graph.microsoft.com/v1.0/me/memberOf?$top=999",
    USERS: "https://graph.microsoft.com/v1.0/users",
    GROUPS: "https://graph.microsoft.com/v1.0/groups"
};

export const GRAPH_REQUESTS = {
    LOGIN: {
        scopes: [
            GRAPH_SCOPES.OPENID,
            GRAPH_SCOPES.PROFILE,
            GRAPH_SCOPES.USER_READ
        ]
    },
    USERS: {
        scopes: [
            GRAPH_SCOPES.USER_READ_ALL,
            //GRAPH_SCOPES.USER_READ_WRITE_ALL,
            GRAPH_SCOPES.DIRECTORY_READ_ALL,
            //GRAPH_SCOPES.DIRECTORY_READ_WRITE_ALL,
        ]
    },
    GROUPS: {
        scopes: [
            GRAPH_SCOPES.GROUP_READ_ALL,
            //GRAPH_SCOPES.GROUP_READ_WRITE_ALL,
            GRAPH_SCOPES.DIRECTORY_READ_ALL,
            //GRAPH_SCOPES.DIRECTORY_READ_WRITE_ALL,
        ]
    }
};

export const msalApp = new UserAgentApplication({
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID!,
        authority: process.env.REACT_APP_AUTHORITY_URL!,
        validateAuthority: true,
        redirectUri: process.env.REACT_APP_REDIRECT_URL!,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: isIE(),
    },
    system: {
        navigateFrameWait: 0,
    },
}
);
